module.exports = __webpack_public_path__ + "images/person.png?b42de4984b90f243e7a584a692675341";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person.png
// module id = VFY2
// module chunks = 0